import React from 'react'
import { Button, Flex, FlexItem } from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'
import {
  evalCondition,
  storeGet,
  STORE_KEY_ACCOUNT
} from 'mailup-react-helpers'
import {
  abTestState,
  fasciaDiNonDisturboInvalidSelector,
  pageState,
  pecPlusConfigState,
  smartPlanningState
} from '../recoil/state/page'
import {
  scheduleNowCallback,
  sendingScheduleSetImmediateCallback,
  sendingScheduleSetScheduleCallback,
  setFasciaDiNonDisturboCallback,
  verifyDateCallback
} from '../recoil/callbacks/callbacks'
import { timeAndCountState } from '../recoil/state/campaign'
import { useHistory } from 'react-router-dom'
import {
  MODE_IMMEDIATE,
  MODE_SCHEDULED,
  MODE_SMART,
  PECPLUS_STATUS_COMPLETE_DESCR
} from 'Constants/index'
import { isScheduledSendingState } from '../recoil/state/sender'
import {
  contentScheduledState,
  isValidDateState,
  setBoxErrorState
} from 'Components/ContentScheduled/recoil/state'

const Footer = () => {
  const intl = useIntl()
  const history = useHistory()
  const { smartPlanningChanged } = useRecoilValue(smartPlanningState)
  const { GracePeriod: gracePeriod } = storeGet(STORE_KEY_ACCOUNT)
  const { isListPecPlus, statusListPecPlus } = useRecoilValue(
    pecPlusConfigState
  )
  const { loading } = useRecoilValue(pageState)
  const { queued: totalQueuedSending } = useRecoilValue(timeAndCountState)
  const { idAbTest, isABTestNotReadyQueue } = useRecoilValue(abTestState)
  const { smartPlanningDateLoaded } = useRecoilValue(smartPlanningState)

  const disableSending = evalCondition('uo:NOSEND')
  const disableSchedule = evalCondition('uo:NOSCHED')
  const disableImmediateSending = evalCondition('uo:NOIMMEDIATESEND')
  const enableSchedulationRedirect = evalCondition('uo:SEND')

  const { isScheduledSending, scheduleModeSelected } = useRecoilValue(
    isScheduledSendingState
  )
  const {
    momentUtcDate,
    momentTimeZoneDate,
    timeZone,
    isDirty: manualSheduledDirty
  } = useRecoilValue(contentScheduledState)
  const isValidDate = useRecoilValue(isValidDateState)
  const verifyDate = useRecoilCallback(verifyDateCallback, [])
  const scheduleNow = useRecoilCallback(scheduleNowCallback, [])
  const sendingScheduleSetImmediate = useRecoilCallback(
    sendingScheduleSetImmediateCallback,
    []
  )
  const sendingScheduleSetSchedule = useRecoilCallback(
    sendingScheduleSetScheduleCallback,
    []
  )
  const setBoxError = useSetRecoilState(setBoxErrorState)
  const fasciaDiNonDisturboInvalid = useRecoilValue(
    fasciaDiNonDisturboInvalidSelector
  )
  const setFasciaDiNonDisturbo = useRecoilCallback(
    setFasciaDiNonDisturboCallback,
    []
  )

  const handleActionImmediato = () => {
    scheduleNow().then(e => {
      if (e) {
        setFasciaDiNonDisturbo('SendNow').then(a => {
          if (a) {
            history.push('/messages/email/sendstatus/campaigns')
          }
        })
      }
      history.push('/messages/email/sendstatus/campaigns')
    })
  }

  const handleActionStandby = () => {
    setFasciaDiNonDisturbo('standBy').then(a => {
      if (a) {
        history.push('/messages/email/sendstatus/campaigns')
      }
    })
  }

  return (
    <>
      <Flex justifyContent='flex-end' columnGap='8px'>
        {enableSchedulationRedirect && (
          <FlexItem>
            <Button
              kind='secondary'
              disabled={loading || fasciaDiNonDisturboInvalid}
              onClick={handleActionStandby}
              data-mu-test='email-sending-queue-manage__action-standby'
            >
              {intl.formatMessage({
                id: 'Load.QueueStatus.ActionStandby'
              })}
            </Button>
          </FlexItem>
        )}
        {isScheduledSending &&
          !disableSending &&
          (!disableImmediateSending || !disableSchedule) && (
            <FlexItem>
              <Button
                disabled={
                  loading ||
                  totalQueuedSending === 0 ||
                  gracePeriod === 2 ||
                  isABTestNotReadyQueue ||
                  !isValidDate ||
                  fasciaDiNonDisturboInvalid ||
                  !smartPlanningDateLoaded
                }
                kind='primary'
                onClick={async () => {
                  if (
                    scheduleModeSelected === MODE_SCHEDULED ||
                    scheduleModeSelected === MODE_SMART
                  ) {
                    const { valid } = await verifyDate(momentTimeZoneDate)
                    if (valid) {
                      sendingScheduleSetSchedule(
                        momentUtcDate,
                        timeZone,
                        scheduleModeSelected
                      ).then(e => {
                        if (e) {
                          setFasciaDiNonDisturbo('scheduled').then(a => {
                            if (a) {
                              history.push(
                                '/messages/email/sendstatus/campaigns'
                              )
                            }
                          })
                        }
                      })
                    } else {
                      setBoxError(true)
                    }
                  }
                  if (scheduleModeSelected === MODE_IMMEDIATE) {
                    sendingScheduleSetImmediate().then(e => {
                      if (e) {
                        setFasciaDiNonDisturbo('SendNow').then(a => {
                          if (a) {
                            history.push('/messages/email/sendstatus/campaigns')
                          }
                        })
                      }
                    })
                  }
                }}
                data-mu-test='email-sending-queue-manage__action-schedule'
              >
                {smartPlanningChanged || manualSheduledDirty
                  ? intl.formatMessage({
                      id: 'Load.QueueStatus.UpdateScheduleBtn'
                    })
                  : intl.formatMessage({
                      id: 'Load.QueueStatus.ActionPianifica'
                    })}
              </Button>
            </FlexItem>
          )}

        {!disableSending &&
          !disableSchedule &&
          !idAbTest > 0 &&
          !disableImmediateSending &&
          !isScheduledSending && (
            <FlexItem>
              <Button
                disabled={
                  (isListPecPlus &&
                    statusListPecPlus !== PECPLUS_STATUS_COMPLETE_DESCR) ||
                  loading ||
                  totalQueuedSending === 0 ||
                  gracePeriod === 2 ||
                  fasciaDiNonDisturboInvalid
                }
                kind='primary'
                onClick={handleActionImmediato}
                data-mu-test='email-sending-queue-manage__action-send-now'
              >
                {intl.formatMessage({
                  id: 'Load.QueueStatus.ActionImmediato'
                })}
              </Button>
            </FlexItem>
          )}
      </Flex>
    </>
  )
}

export default Footer
